import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#f5b6c1',
                secondary: '#ed717c',
                accent: '#14365b',
                blank: '#ffffff',
                light: '#fff8fc',
                gray: '#6F83A1'
            },
        },
    },
});
